module.exports = __webpack_public_path__ + "img/home_personal_normal.6ccba34f.svg";